"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProvideMousePosition = exports.MousePositionContext = void 0;

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// tslint:disable-next-line:completed-docs
var MousePositionContext = _react.default.createContext({
  x: 0,
  y: 0
}); // tslint:disable-next-line:completed-docs


exports.MousePositionContext = MousePositionContext;

var ProvideMousePosition = function ProvideMousePosition(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)({
    x: 0,
    y: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  (0, _react.useEffect)(function () {
    var setMousePosition = function setMousePosition(ev) {
      setState({
        x: ev.clientX,
        y: ev.clientY
      });
    };

    window.addEventListener("mousemove", setMousePosition);
    return function () {
      window.removeEventListener("mousemove", setMousePosition);
    };
  }, [false]);
  return _react.default.createElement(MousePositionContext.Provider, {
    value: state
  }, children);
};

exports.ProvideMousePosition = ProvideMousePosition;
ProvideMousePosition.displayName = "ProvideMousePosition";
//# sourceMappingURL=MousePositionContext.js.map